import UserStatusEnum from "../enums/user-status.enum";


export const GREEN_STATUS = [UserStatusEnum.ACTIVO, UserStatusEnum.RENOVADO]
export const ORANGE_STATUS = [UserStatusEnum.PDTE_CONFIRMACION, UserStatusEnum.PDTE_CONTRATO_SERVICIO, UserStatusEnum.PDTE_FIRMA_DATOS, UserStatusEnum.PDTE_VALIDACION, UserStatusEnum.PENDIENTE]
export const RED_STATUS = [UserStatusEnum.BAJA, UserStatusEnum.BLOQUEADO, UserStatusEnum.NO_ACTIVO, UserStatusEnum.RECHAZADO_TPV, UserStatusEnum.RECHAZO_TPV_RENOV]